import Vue from "vue";
import Vuex from "vuex";
import { actions } from "./modules/index";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    products: [],
    product: undefined,
  },
  mutations: {},
  methods: {},
  actions: {
    ...actions,
  },
});
